export const NFT_SECTION_ITEM_LIMIT = 100;
export const PROFILE_PAGE_WRAPPER_ID = 'PROFILE_PAGE_WRAPPER';
